<template>
	<template v-if="hasPanels">
		<div v-if="hasStickyPanels" class="sticky-panels" :class="{'last-panels-block': !hasNonStickyPanels}">
			<TransitionGroup name="list">
				<template v-for="p in stickyPanels" :key="p.id">
					<component :is="resoveActionPanelComponent(p.type)" v-bind="panelBinding(p)" :panel="p"></component>
				</template>
			</TransitionGroup>
		</div>
		<div v-if="hasNonStickyPanels" class="action-panels last-panels-block">
			<TransitionGroup name="list">
				<template v-for="p in nonStickyPanels" :key="p.id">
					<component :is="resoveActionPanelComponent(p.type)" v-bind="panelBinding(p)" :panel="p"></component>
				</template>
			</TransitionGroup>
		</div>
	</template>
</template>

<script setup lang="ts">
import {ref, computed, onMounted, onUnmounted} from "vue";
import type {FormEnvironment} from "@fd/Types.ts";
import {injectEnv} from "@fd/Environment.ts";
import {useNavigationStore} from "@/store/NavigationStore.ts";
import {resoveActionPanelComponent, panelBinding} from "@/ui/action-panel/ActionPanelResolver.ts";
import crmWS from "@/ws/UniversalSocket.ts";
import {WsRecipient} from "@/ws/WsRecipient.ts";
import {ActionPanelInstance} from "@t/ui/ActionPanel.ts";

const env:FormEnvironment = injectEnv();
const navStore = useNavigationStore();

const hasPanels = computed<boolean>(() => navStore.actionPanels.length > 0);
const hasStickyPanels = computed<boolean>(() => stickyPanels.value.length > 0);
const hasNonStickyPanels = computed<boolean>(() => nonStickyPanels.value.length > 0);

const stickyPanels = computed<ActionPanelInstance<any>[]>(() => {
	const sp:ActionPanelInstance<any>[] = [];
	for (const p of navStore.actionPanels) {
		if (p.sticky) sp.push(p);
	}
	return sp;
});

const nonStickyPanels = computed<ActionPanelInstance<any>[]>(() => {
	const sp:ActionPanelInstance<any>[] = [];
	for (const p of navStore.actionPanels) {
		if (!p.sticky) sp.push(p);
	}
	return sp;
});

const wsRecipient:WsRecipient = {
	onMessage: (sender:string, message:any) => {
		if (typeof message === "object" && message?.type === "reload") {
			// Reload command from the backend
			navStore.loadActionPanels();
		}
		//console.log("Action panels received from '"+sender+"': "+JSON.stringify(message));
	},

	onOpen: () => {
		console.log("Action panels WS opened");
	},

	onClose: () =>  {
		console.log("Action panels WS closed");
	}
}

onMounted(() => {
	crmWS.register("action-panels", wsRecipient);
});
</script>

<style>
.action-panels, .sticky-panels {
	display: flex;
	flex-direction: column;
	row-gap: 8px;
}
.action-panels {
	position: relative;
}
.sticky-panels {
	position: sticky;
	top: 8px;
	z-index: var(--floater-z-index);
}
.menubar > .sticky-panels,
.menubar > .action-panels {
	margin-bottom: 8px;
}

.menubar > .last-panels-block {
	margin-bottom: 16px;
}
</style>